import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";

import { createVuetify } from "vuetify";
import "vuetify/styles/main.css";
import "@mdi/font/css/materialdesignicons.css";

// プロダクトリソースを初期化（タイトル、favicon）
import { initProductResources } from "./function/setting/ProductResources";

// タイトルとfaviconを動的に設定
initProductResources("試用版申込フォーム");

const vuetify = createVuetify({
  icons: {
    defaultSet: "mdi",
  },
  defaults: {
    VTextField: {
      clearable: false,
    },
    VSelect: {
      clearable: false,
    },
  },
});

createApp(App).use(createPinia()).use(router).use(vuetify).mount("#app");
